import type { VoidFunctionComponent } from 'react';

import RouterLink from '../../../../generic/Link/RouterLink';
import PaginationRangeWithControl from '../../../../generic/Pagination/PaginationRangeWithControl';

import styles from './ReleaseSelector.module.less';

type Props = {
  projectGroupId: number;
  page: number;
  count: number;
  total?: number;
  setPage: (page: number) => void;
};

/**
 * ReleaseGroupsReleaseSelectorFooter renders the pagination controls for the release selector.
 */
const ReleaseGroupsReleaseSelectorFooter: VoidFunctionComponent<Props> = ({
  projectGroupId,
  page,
  count,
  total,
  setPage,
}) => (
  <footer className={styles.footer}>
    <div className={styles.footerPadded}>
      <PaginationRangeWithControl
        page={page}
        count={count}
        totalItems={total || 0}
        setPage={setPage}
      />
    </div>
    <div className={`${styles.footerPadded} ${styles.footerLink}`}>
      <RouterLink to={`/projects/group/${projectGroupId}/releases`}>
        Manage Releases
      </RouterLink>
    </div>
  </footer>
);

export default ReleaseGroupsReleaseSelectorFooter;
